import PolygonBase from './PolygonBase';
import shapeProcessEnd from '../assets/icons/shapeProcessEnd.svg';
import { svgToIcon } from '../utils/svg';

const HEIGHT_FACTOR = 0.5;
class ShapeProcessEnd extends PolygonBase {
  static renderIcon() {
    return svgToIcon(shapeProcessEnd);
  }

  changedToShape() {
    super.changedToShape();

    // processEnd just looks like a circle if its dimensions are equal, so ensure it's wider than it is tall
    this.fabricObject.set(
      'width',
      Math.max(
        this.fabricObject.width,
        this.fabricObject.height / HEIGHT_FACTOR
      )
    );
  }

  static defaultHeight() {
    return this.defaultWidth() * HEIGHT_FACTOR;
  }

  static pathString() {
    const r = 0.5;

    return `
      M -${0.5 - r} -0.5
      L ${0.5 - r} -0.5
      R ${r} 0
      L 0.5 ${0.5 - r}
      R ${r} 1
      L -${0.5 - r} 0.5
      R ${r} 2
      L -0.5 -${0.5 - r}
      R ${r} 3
      Z
    `;
  }

  calcTextMargin() {
    const offset = 0.15 * this.fabricObject.width;

    return { ...super.calcTextMargin(), left: offset, right: offset };
  }
}

export default ShapeProcessEnd;
